import IconButtonMui from '@mui/material/IconButton';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';

import { IHeader } from './types';
import * as S from './styles';

const AppHeader = ({ title, backArrow, backPagePress, description, $width = '100%' }: IHeader) => {
  const navigate = useNavigate();

  return (
    <S.Header $size={$width}>
      {title && (
        <S.ContainerMainText>
          <S.ContainerTitle>
            {backArrow && (
              <IconButtonMui
                sx={{ color: 'primary.main' }}
                onClick={() => (backPagePress ? backPagePress() : navigate(-1))}
              >
                <ArrowBack />
              </IconButtonMui>
            )}
            <Stack gap={1.5} paddingLeft={backArrow ? 0 : 5}>
              {title && <S.Title>{title}</S.Title>}
              {description && <S.Description>{description}</S.Description>}
            </Stack>
          </S.ContainerTitle>
        </S.ContainerMainText>
      )}
    </S.Header>
  );
};

export default AppHeader;
